<template>
  <div class="deviceType">
    <el-form :inline="true" :model="searchForm" class="demo-form-inline" label-width="90px">
      <el-form-item label="名称" label-width="40px">
        <el-input style="width: 140px" @input="search" clearable v-model="searchForm.name" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="编码">
        <el-input style="width: 140px" @input="search" clearable v-model="searchForm.code" placeholder="请输入"></el-input>
      </el-form-item>
    </el-form>
    <div style="margin-bottom: 20px">
      <el-button type="primary" @click="search">查询<i class="el-icon-search el-icon--right"></i></el-button>
      <el-button type="info" @click="clear">重置<i class="el-icon-refresh-right el-icon--right"></i></el-button>
      <el-button type="warning" @click="addItem">新增<i class="el-icon-plus el-icon--right"></i></el-button>
    </div>
    <div style="border: 1px solid #c9cdd6">
      <el-table
          :header-cell-style="{background:'#F5F5F5'}"
          :data="tableData"
          max-height="600"
          style="width: 100%"
      >
        <el-table-column
            prop="order"
            label="序号">
        </el-table-column>
        <el-table-column
            prop="name"
            label="类型名称">
        </el-table-column>
        <el-table-column
            prop="code"
            label="类型编号">
        </el-table-column>
        <el-table-column
            prop="version"
            label="版本">
        </el-table-column>
        <el-table-column
            prop="note"
            label="备注">
        </el-table-column>
        <el-table-column
            prop="deviceImage"
            label="设备图片">
          <template slot-scope="scope">
            <el-image
                style="width: 100px; height: 100px"
                :src="getImg(scope.row.imageId)"
                :preview-src-list="srcList(scope.row.deviceImage)">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column
            prop="address"
            fixed="right"
            width="150"
            align="center"
            label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="medium" @click="editorClick(scope.row)">编辑</el-button>
            <el-button type="text" size="medium" @click="uploadClick(scope.row)">上传设备图片</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div style="margin-top: 20px">
      <Pagination :total='total' :currentPage='currPage' :pageSize='pageSize' @handleSizeChange='handleSizeChange'
                  @handleCurrentChange='handleCurrentChange'></Pagination>
    </div>
    <el-dialog
        :title="modelTitle"
        :close-on-click-modal="false"
        :visible.sync="dialogVisible"
        width="30%">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="80px" class="demo-ruleForm">
        <el-form-item label="类型名称" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="类型编号" prop="code">
          <el-input v-model="ruleForm.code" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="版本">
          <el-input v-model="ruleForm.version" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="序号">
          <el-input v-model="ruleForm.order" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="保养计划">
          <el-select v-model="ruleForm.maintainScheduleId" style="width: 100%" placeholder="请选择">
            <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="ruleForm.note" placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitForm('ruleForm')">确定</el-button>
          <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
        title="设备图片"
        :visible.sync="pictureDialog"
        width="55%">
      <div>
        <upload
            :limitCount='10'
            :imgDisabled="imgDisabled"
            @delImgPath="delImgPath"
            @addPath="addPath"
            :DeviceTypeId="DeviceTypeId"
            :fileList="fileList"
        >
        </upload>
      </div>
      <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="submitIMG('ruleForm')">确 定</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import upload from "@/components/deviceUpload";
export default {
  name: "deviceType",
  data() {
    return {
      tableData: [],
      searchForm: {
        name: '',
        code: '',
        parentCode: '',
      },
      options: [],
      modelTitle: '新增设备类型',
      dialogVisible: false,
      pictureDialog: false,
      imgDisabled:false,
      DeviceTypeId:'',
      ruleForm: {
        address: '',
        corporate: '',
        license: '',
        corporateIdCard: '',
        email: '',
        phone: '',
        name: '',
        code: '',
        note: ''
      },
      fileList:[],
      rules: {
        name: [
          {required: true, message: '请输入名称', trigger: 'blur'},
        ],
        code: [
          {required: true, message: '请输入编码', trigger: 'blur'},
        ],
      },
      areaId: '',
      total: 0, //总条数
      currPage: 1,//当前页码
      pageSize: 10, //每页条数
      imgArray:[],
    }
  },
  components: {
    //someComponent
    Pagination,
    upload
  },
  methods: {
    getImg(i){
      return this.axios.defaults.baseURL+'/api/File/'+ i
    },
    srcList(i){
      let imgOBJ=JSON.parse(i)
      let imgList=[]
      if(imgOBJ)
          imgOBJ.forEach(item=>{
            imgList.push(this.axios.defaults.baseURL+'/api/File/'+ item)
          })
      return imgList
    },
    //搜索
    search() {
      this.currPage = 1 //当前页码
      this.pageSize = 10 //每页条数
      this.init()
    },
    clear() {
      this.searchForm = {
        name: '',
        code: '',
        parentCode: ''
      }
      this.currPage = 1 //当前页码
      this.pageSize = 10 //每页条数
      this.init()
    },
    addItem() {
      this.modelTitle = '新增设备类型'
      this.ruleForm = {}
      this.dialogVisible = true
    },
    editorClick(row) {
      this.modelTitle = '编辑设备类型'
      this.areaId = row.id
      this.ruleForm = {
        ...row
      }
      this.dialogVisible = true
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            ...this.ruleForm,
          }
          if (this.modelTitle === '编辑设备类型') {
            this.axios
                .put("api/DeviceType?id=" + this.areaId, data).then((res) => {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.$refs[formName].resetFields();
              this.dialogVisible = false
              this.init()
            })
          } else {
            this.axios
                 .post("api/DeviceType", data).then((res) => {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.$refs[formName].resetFields();
              this.dialogVisible = false
              this.init()
            })
          }
        } else {
          return false;
        }
      });
    },
    uploadClick(row){
      this.fileList=[]
      let imgOBJ=JSON.parse(row.deviceImage)
      if(imgOBJ)
      imgOBJ.forEach(item=>{
        let obj={
          name:item,
          url:this.axios.defaults.baseURL+'/api/File/'+ item
        }
        this.fileList.push(obj)
      })
      this.DeviceTypeId=row.id
      this.pictureDialog=true
    },
    addPath(e){
        let obj= {
          name:e[e.length-1],
          url: this.axios.defaults.baseURL + '/api/File/' + e[e.length-1]
        }
        this.fileList.push(obj)
      this.init()
    },
    delImgPath(e){
      this.fileList=this.fileList.filter(item=>{
       return  item.name!==e
      })
      this.init()
    },
    submitIMG() {
      this.init()
      this.pictureDialog=false
    },
    // ----------分页控制-------------
    handleSizeChange(val) {
      this.pageSize = val
      this.init()
    },
    handleCurrentChange(val) {
      this.currPage = val
      this.init()
    },

    // list
    init() {
      let data = {
        name: this.searchForm.name,
        code: this.searchForm.code,
        page: this.currPage,
        pageSize: this.pageSize,
      }
      this.axios
          .get("api/DeviceType", {params: data})
          .then((res) => {
            this.tableData=res.list
            this.total = res.count
          })
    },
    optionsList() {
      this.axios
          .get("api/MaintainSchedule")
          .then((res) => {
            let obj = []
            res.list.forEach(item => {
              obj.push(
                  {
                    value: item.id,
                    label:  item.name
                  }
              )
            })
            this.options=obj
          })
    }
  },
  mounted() {
    //
    this.init()
    this.optionsList()
  }
}
</script>

<style lang="scss" scoped>
.deviceType {

}
</style>